<template>
  <div>
    <div class="app-main-inner-row" style="padding-top: 10px;">
      <div class="filters">
        <el-form
          :inline="true"
          label-width="50px"
          label-position="left"
          @submit.native.prevent="filter.pageNum=1;toQuery()"
        >
          <el-form-item :label="$t('common.btn.query')">
            <el-input
              v-model="filter.likeName"
              no="queryInput"
              :placeholder="$t('common.tips.fuzzySearch')"
              style="width:310px"
            />
          </el-form-item>
        </el-form>
      </div>
      <div class="triggers">
        <el-button no="query" type="primary" @click="filter.pageNum=1;toQuery()">{{ $t('common.btn.query') }}</el-button>
        <el-button v-show="tenantId!==PLATFORM_TENANT_ID" no="queryInput" type="primary" @click="showEditDialog(true, 'systemAdd')">{{ $t('SeaExport.SystemAdd') }}</el-button>
        <el-button no="new" type="primary" @click="showEditDialog(true)">{{ $t('common.btn.new') }}</el-button>
        <el-button no="edit" type="primary" @click="showEditDialog(false)">{{ $t('common.btn.edit') }}</el-button>
        <el-button no="delete" type="danger" @click="remove">{{ $t('common.btn.delete') }}</el-button>
      </div>
    </div>
    <div class="app-main-inner-row row-grid">
      <cargo-ag-grid
        no="grid"
        config-module="101372"
        :grid-params.sync="girdParams"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
      />
    </div>
    <div class="app-main-inner-row row-pagination">
      <cargo-pagination
        v-show="total>0"
        no="pagination"
        :total="total"
        :page.sync="filter.pageNum"
        :limit.sync="filter.pageSize"
        @pagination="toQuery"
      />
    </div>
    <!-- 编辑弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="editDialog.visible"
      :title="editDialog.title"
      width="500px"
      :close-on-click-modal="false"
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form label-width="110px" label-position="left" :disabled="tenantId!==PLATFORM_TENANT_ID && editDialog.form.isPlatform">
          <el-form-item :label="$t('baseInfo.basicData.baseCustomsDeclarationType.code')">
            <el-input v-model="editDialog.form.code" no="code" />
          </el-form-item>
          <el-form-item :label="$t('baseInfo.basicData.baseCustomsDeclarationType.name')">
            <el-input v-model="editDialog.form.name" no="name" />
          </el-form-item>
          <el-form-item :label="$t('baseInfo.basicData.baseCustomsDeclarationType.englishName')">
            <el-input v-model="editDialog.form.englishName" no="englishName" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button no="editSave" type="primary" @click="save">{{ $t('common.btn.save') }}</el-button>
        <el-button no="editCancel" @click="editDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
    <!-- 新增弹窗（非平台维护） -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="platformDialog.visible"
      :title="$t('SeaExport.SystemAdd')"
      width="950px"
      :close-on-click-modal="false"
    >
      <base-customs-declaration-type />
      <span slot="footer" class="dialog-footer">
        <el-button no="add" size="mini" type="primary" @click="addFromPlatform">{{ $t('common.btn.add') }}</el-button>
        <el-button no="cancel" size="mini" @click="platformDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import baseCustomsDeclarationType from './baseCustomsDeclarationType'
import { getUserInfo } from '@/utils/auth'
import {
  addCustomsDeclarationTypeByPlatform,
  delCustomsDeclarationType,
  getCustomsDeclarationTypeList,
  getCustomsDeclarationTypesByPlatform, saveCustomsDeclarationType,
  saveCustomsDeclarationTypes
} from '@/api/basicData/customsDeclarationType'
import { getLoading } from '@/utils/utilBaseElement'

export default {
  name: 'CustomsDeclarationType',
  components: { baseCustomsDeclarationType },
  data() {
    return {
      PLATFORM_TENANT_ID: 1, // 平台维护的租户ID
      filter: {
        likeName: '',
        pageNum: 1,
        pageSize: 50
      },
      total: 0,
      girdParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          menuTabs: [], // 去掉每列的菜单
          filter: true
        }
      },
      columnDefs: [
        {
          headerName: '',
          checkboxSelection: true,
          width: 55,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        },
        {
          headerName: this.$t('baseInfo.basicData.baseCustomsDeclarationType.code'),
          field: 'code',
          width: 100
        },
        {
          headerName: this.$t('baseInfo.basicData.baseCustomsDeclarationType.name'),
          field: 'name',
          width: 200
        },
        {
          headerName: this.$t('baseInfo.basicData.baseCustomsDeclarationType.englishName'),
          field: 'englishName',
          width: 200
        },
        {
          headerName: this.$t('baseInfo.basicData.baseCustomsDeclarationType.isPlatform'),
          field: 'isPlatform',
          width: 200,
          cellRenderer: params => {
            return params.value ? this.$t('SeaExport.yes') : this.$t('SeaExport.no')
          }
        }
      ],
      rowData: null,
      tenantId: '',
      editDialog: { // 新增，编辑弹框
        visible: false,
        title: '',
        form: {
          uuid: '',
          code: '',
          name: '',
          englishName: ''
        }
      },
      platformDialog: { // 系统新增弹框
        visible: false
      }
    }
  },
  computed: {
    gridApi() {
      return this.girdParams.api
    }
  },
  created() {
    const user = getUserInfo()
    this.tenantId = user.tenantId
  },
  methods: {
    onShow() {
      if (this.rowData === null) {
        this.rowData = []
        this.toQuery()
      }
    },
    toQuery() {
      const self = this
      let queryFunc = getCustomsDeclarationTypeList
      if (self.tenantId === self.PLATFORM_TENANT_ID) {
        queryFunc = getCustomsDeclarationTypesByPlatform
      }
      const loading = getLoading()
      queryFunc(self.filter).then(res => {
        if (self.gridApi) {
          self.gridApi.setRowData(res.data.list)
        } else {
          self.rowData = res.data.list
        }
        self.filter.pageNum = res.data.pageNum
        self.filter.pageSize = res.data.pageSize
        self.total = Number(res.data.total)
      }).finally(() => loading.close())
    },
    showEditDialog(isNew, type) {
      if (isNew) {
        if (this.tenantId !== this.PLATFORM_TENANT_ID && (type === 'systemAdd')) {
          this.showPlatform()
          return
        }
        this.editDialog.form = {
          uuid: '',
          code: '',
          name: '',
          englishName: ''
        }
        this.editDialog.title = this.$t('CargoMsg.Cargo_NewTo') + this.$t('SeaExport.CustomsDeclarationType')
      } else {
        const rows = this.gridApi.getSelectedRows()
        if (rows.length === 0) {
          this.$message.warning(this.$t('common.tips.hasOneAtleast'))
          return
        }
        if (rows[0].isPlatform) {
          this.$message.warning(this.$t('baseInfo.basicData.baseCustomsDeclarationType.PlatformTip'))
          return
        }
        this.editDialog.form = { ...rows[0] }
        this.editDialog.title = this.$t('CargoMsg.Cargo_EditTo') + this.$t('SeaExport.CustomsDeclarationType')
      }
      this.editDialog.visible = true
    },
    serialNumberBlur() {
      const form = this.editDialog.form
      const val = Number(form.serialNumber)
      if (isNaN(val)) {
        form.serialNumber = ''
        return
      }
      form.serialNumber = val.toFixed(0)
    },
    save() {
      const self = this
      const form = self.editDialog.form
      if (!form.code) {
        self.$message.warning(self.$t('baseInfo.basicData.baseCustomsDeclarationType.codeCheck'))
        return
      }
      if (form.code.length > 60) {
        self.$message.warning(self.$t('baseInfo.basicData.baseCustomsDeclarationType.codeTooLong'))
        return
      }
      if (!form.name) {
        self.$message.warning(self.$t('baseInfo.basicData.baseCustomsDeclarationType.nameCheck'))
        return
      }
      if (form.name.length > 60) {
        self.$message.warning(self.$t('baseInfo.basicData.baseCustomsDeclarationType.nameTooLong'))
        return
      }
      if (!form.englishName) {
        self.$message.warning(self.$t('baseInfo.basicData.baseCustomsDeclarationType.englishNameCheck'))
        return
      }
      if (form.englishName.length > 60) {
        self.$message.warning(self.$t('baseInfo.basicData.baseCustomsDeclarationType.englishNameTooLong'))
        return
      }
      let saveFunc = saveCustomsDeclarationType
      if (!form.uuid && self.tenantId === self.PLATFORM_TENANT_ID) {
        saveFunc = addCustomsDeclarationTypeByPlatform
      }
      saveFunc(form).then(res => {
        if (!form.uuid) {
          self.filter.pageNum = 1
        }
        self.toQuery()
        self.editDialog.visible = false
        self.$message.success(self.$t('common.tips.saveSuccess'))
      })
    },
    remove() {
      const self = this
      const rows = self.gridApi.getSelectedRows()
      if (rows.length === 0) {
        self.$message.warning(self.$t('common.tips.hasOneAtleast'))
        return
      }
      self.$confirm(self.$t('common.tips.confirmDelete'), self.$t('common.tips.prompt'), {
        confirmButtonText: self.$t('common.btn.ok'),
        cancelButtonText: self.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        this.syncRemove(rows, 0)
      }).catch(() => {
      })
    },
    syncRemove(rows, index) {
      if (index < rows.length) {
        const params = { uuid: rows[index].uuid, customsDeclarationTypeId: rows[index].customsDeclarationTypeId }
        delCustomsDeclarationType(params).then(res => {
          this.syncRemove(rows, index + 1)
        }).catch(() => {
          if (index > 0) {
            this.filter.pageNum = 1
            this.toQuery()
          }
        })
      } else {
        this.filter.pageNum = 1
        this.toQuery()
        this.$message.success(this.$t('common.tips.deleteSuccess'))
      }
    },
    showPlatform() {
      if (document.resetBaseCustomsDeclarationType) {
        document.resetBaseCustomsDeclarationType()
      } else {
        setTimeout(() => {
          document.resetBaseCustomsDeclarationType()
        })
      }
      this.platformDialog.visible = true
    },
    /**
     * 系统新增，查询平台数据，选择新增到租户
     */
    addFromPlatform() {
      const self = this
      const rows = document.getSelectedBaseCustomsDeclarationTypeRows()
      if (rows.length === 0) {
        self.$message.warning(self.$t('common.tips.hasOneAtleast'))
        return
      }
      const form = []
      for (let i = 0; i < rows.length; ++i) {
        const item = rows[i]
        form.push({
          code: item.code,
          name: item.name,
          englishName: item.englishName,
          customsDeclarationTypeId: item.customsDeclarationTypeId
        })
      }
      saveCustomsDeclarationTypes(form).then(res => {
        self.filter.pageNum = 1
        self.toQuery()
        self.platformDialog.visible = false
        self.$message.success(self.$t('common.tips.saveSuccess'))
      }).catch(() => {
        self.platformDialog.visible = false
      })
    }
  }
}
</script>

<style>
</style>
